<template>
  <div class="page-wrapper">

  <!-- Fullscreen Loader -->
  <div v-if="isLoading" class="tenant-loader-overlay">
    <img src="@/assets/img/LOADER-03.gif" alt="Loading..." class="tenant-loader-gif" />
  </div>
  <div class="tenant-cards">
  <div class="row g-2">

    <!-- Total Tenants -->
    <div class="col-lg-3 col-md-6">
      <div class="tenant-card total-card">
        <div class="card-top">
          <div class="icon-box blue">
            <i class="fas fa-building"></i>
          </div>

          <div class="icon-bg">
            <!-- <i class="fas fa-chart-line"></i> -->
               <span class="tdesign--building"></span>
          </div>
        </div>

        <h6>Total Tenants</h6>
        <h2>04</h2>
        <p>All registered tenants</p>
      </div>
    </div>

    <!-- Active Tenants -->
    <div class="col-lg-3 col-md-6">
      <div class="tenant-card active-card">
        <div class="card-top">
          <div class="icon-box green">
            <i class="fas fa-check"></i>
          </div>

          <div class="progress-ring">
            <span>75%</span>
          </div>
        </div>

        <h6>Active Tenants</h6>
        <h2>03</h2>
        <p>75% of total tenants</p>
      </div>
    </div>

    <!-- Regions -->
    <div class="col-lg-3 col-md-6">
      <div class="tenant-card region-card">
        <div class="card-top">
          <div class="icon-box purple">
            <i class="fas fa-globe"></i>
          </div>

          <div class="icon-bg">
            <span class="arcticons--map"></span>
            <!-- <i class="fas fa-map-marked-alt"></i> -->
          </div>
        </div>

        <h6>Regions</h6>
        <h2>02</h2>
        <p>Geographic regions</p>
      </div>
    </div>

    <!-- Inactive -->
    <div class="col-lg-3 col-md-6">
      <div class="tenant-card inactive-card">
        <div class="card-top">
          <div class="icon-box orange">
            <i class="fas fa-exclamation-triangle"></i>
          </div>

          <div class="icon-bg">
            <i class="fas fa-user-times"></i>
            <!-- <span class="fa6-solid--building-circle-exclamation"></span> -->
          </div>
        </div>

        <h6>Inactive Tenants</h6>
        <h2>01</h2>
        <p>Needs attention</p>
      </div>
    </div>

  </div>
  </div>

 <div class="filter-wrapper">

  <div class="filter-header">
    <div class="filter-title">
      <i class="fa fa-sliders"></i>
      <span>Quick Filters</span>
    </div>

    <button class="filter-toggle">
      Hide Filters <i class="fa fa-chevron-up"></i>
    </button>
  </div>

  <div class="filter-row">
  <div class="filter-group search-group">
    <label>Search</label>
    <div class="search-box">
      <input
        type="search"
        placeholder="Search tenant name, code or email..."
        v-model="filters.search"
        @keyup.enter="applyFilters"
      />
      <i class="fa fa-search text-end"></i>
    </div>
  </div>

  <div class="filter-group">
    <label>Region</label>
    <select v-model="filters.region">
      <option value="">All Regions</option>
      <option value="IN">IN</option>
      <option value="EU">EU</option>
      <option value="US">US</option>
    </select>
  </div>

  <div class="filter-group">
    <label>Environment</label>
    <select v-model="filters.environment">
      <option value="">All Environments</option>
      <option value="Production">Production</option>
      <option value="UAT">UAT</option>
      <option value="Development">Development</option>
    </select>
  </div>

  <div class="filter-group">
    <label>Status</label>
    <select v-model="filters.status">
      <option value="">All Status</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
    </select>
  </div>

  <div class="filter-group">
    <label>Tenant Code</label>
    <input type="text" placeholder="Enter tenant code" v-model="filters.tenantCode" />
  </div>
</div>

<div class="filter-row mt-3">
  <div class="filter-actions">
    <button class="btn-reset" @click="resetFilters">
      <i class="fa fa-refresh text-danger"></i> Reset
    </button>

    <button class="btn-apply" @click="applyFilters">
      <i class="fa fa-filter"></i> Apply Filters
    </button>
  </div>
</div>

  <!-- <div class="more-filters">
    <i class="fa fa-chevron-down"></i>
    More Filters
  </div> -->
</div>
  <div class="module-card">
    
    <div class="module-header mb-2">
      <h2>Tenant list</h2>
      <button class="add-module-btn" aria-label="Add Tenant" title="Add Tenant" @click="openAddModule">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <span>Create Tenant</span>
      </button>
    </div>

<div class="table-scroll">
<table class="module-table">
  <colgroup>
    <col style="width: 14%;">
    <col style="width: 10%;">
    <col style="width: 16%;">
    <col style="width: 20%;">
    <col style="width: 8%;">
    <col style="width: 8%;">
    <col style="width: 8%;">
    <col style="width: 8%;">
    <col style="width: 7%;">
    <col style="width: 7%;">
  </colgroup>
  <thead>
    <tr>
      <th>Tenant Name</th>
      <th>Tenant Code</th>
      <th>Root User Email</th>
      <th>Url</th>
      <th class="text-center">Region</th>
      <th class="text-center">Environment</th>
      <th class="text-center">Status</th>
      <th class="text-center">Tenant Config</th>
      <th class="text-center">Edit</th>
      <th class="text-center">Delete</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in filteredTenants" :key="item.id">
      <td data-label="Tenant Name">{{ item.tenantName }}</td>
      <td data-label="Tenant Code">{{ item.tenantCode }}</td>
      <td data-label="Root User Email">{{ item.rootUserEmail }}</td>
      <td class="description-cell" data-label="Url">
        <span class="description-text" :class="{ expanded: isExpanded(item.id) }">{{ item.url }}</span>
        <a v-if="item.url && item.url.length > 80" class="more-less-link" @click="toggleDescription(item.id)">{{ isExpanded(item.id) ? 'less' : 'more' }}</a>
      </td>
      <td class="center" data-label="Region">{{ item.region }}</td>
      <td class="center" data-label="Environment">{{ item.environment }}</td>
      <td class="center" data-label="Status">
        <span class="badge" :class="{ inactive: !item.active }">{{ item.active ? 'Active' : 'Inactive' }}</span>
      </td>
      <td class="center" data-label="Tenant Configuration">
        <i class="fa-solid fa-gear config-icon" title="Configure License" @click="openLicenseModal(item)"></i>
      </td>
      <td class="center" data-label="Edit"><i class="fa-solid fa-pen-to-square" @click="openEditModule(item)"></i></td>
      <td class="center" data-label="Delete"><i class="fa-solid fa-trash" @click="deleteModule(item)"></i></td>
    </tr>
  </tbody>
</table>
</div>

    <!-- Pagination -->
    <div class="pagination-bar" v-if="totalCount > 0">
      <span class="pagination-info">
        Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }}
      </span>
      <div class="pagination-controls">
        <button
          type="button"
          class="page-btn"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <span class="page-indicator">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          type="button"
          class="page-btn"
          :disabled="currentPage === totalPages"
          @click="nextPage"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Create / Edit tenant modal -->
    <TenantModel
      ref="TenantModel"
      @TenantModel-created="onTenantModelSaved"
      @TenantModel-updated="onTenantModelSaved"
    />

    <!-- Tenant License Configuration modal -->
    <TenantLicenseModel
      ref="TenantLicenseModel"
      @license-saved="onTenantModelSaved"
    />
  </div>
  </div>
</template>
<style scoped>
.tenant-loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
}
.tenant-loader-gif {
  width: 120px;
  height: auto;
}

.page-wrapper {
  overflow-x: hidden;
}

.filter-wrapper {
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  margin-top: 12px;
  border: 1px solid #e8edf5;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
}

.filter-title i {
  color: #2563eb;
}

.filter-toggle {
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
}

.filter-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
}

.filter-group label {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #334155;
}

.filter-group input,
.filter-group select {
  height: 30px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 10px;
  outline: none;
}

.filter-group input:focus,
.filter-group select:focus {
  border-color: #2563eb;
}

.search-box {
  position: relative;
}

.search-box input {
  width: 100%;
  padding-right: 40px;
}

.search-box i {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}

.more-filters {
  margin-top: 18px;
  font-size: 10px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}

.filter-actions {
  display: flex;
  align-items: end;
  gap: 10px;
}

.btn-reset {
  height: 32px;
  padding: 0 18px;
  font-size:8px;
  border: 1px solid #dbe3ef;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
}

.btn-apply {
  height: 32px;
  padding: 0 20px;
  font-size:8px;
  border: none;
  background:#0f6e56;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.btn-apply:hover {
  background: #15803d;
}
.tenant-cards {
  margin-top: 20px;
}

.tenant-card {
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  border: 1px solid #e8edf5;
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  transition: all .3s ease;
  height: 100%;
}

.tenant-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0,0,0,.08);
}

.total-card {
  border-top: 4px solid #2563eb;
}

.active-card {
  border-top: 4px solid #22c55e;
}

.region-card {
  border-top: 4px solid #8b5cf6;
}

.inactive-card {
  border-top: 4px solid #f97316;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.icon-box {
  width: 24px;
  height: 24px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.blue {
  background: #2563eb;
}

.green {
  background: #22c55e;
}

.purple {
  background: #8b5cf6;
}

.orange {
  background: #f97316;
}

.icon-bg {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2d0303;
  font-size: 12px;
}

.tenant-card h6 {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.tenant-card h2 {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 8px;
}

.total-card h2 {
  color: #2563eb;
}

.active-card h2 {
  color: #22c55e;
}

.region-card h2 {
  color: #8b5cf6;
}

.inactive-card h2 {
  color: #f97316;
}

.tenant-card p {
  margin: 0;
  color: #64748b;
  font-size: 10px;
}

.progress-ring {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 6px solid #dcfce7;
  border-top-color: #22c55e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-weight: 700;
  color: #22c55e;
}
.tdesign--building {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cg fill='none'%3E%3Cpath d='M16 6h3v4h1v11H4V10h1V6h3V3h8z'/%3E%3Cpath d='M9 15v6h6v-6z'/%3E%3Cpath stroke='%231e4060' stroke-linecap='square' stroke-width='1' d='M9 15v6h6v-6zm7-9V3H8v3m8 0h3v4m-3-4H8m0 0H5v4m14 0H5m14 0h1M5 10H4m0 0v11m0-11H3m1 11H3m1 0h16m0-11v11m0-11h1m-1 11h1'/%3E%3C/g%3E%3C/svg%3E");
}
.arcticons--map {
  display: inline-block;
  width: 48px;
  height: 48px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #2d0303;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath fill='none' stroke='%2322052a' stroke-linecap='round' stroke-linejoin='round' d='M24 4.5A14.82 14.82 0 0 0 9.18 19.32h0v1.08c.6 8.12 7.34 14.65 14.82 23.1c7.81-8.82 14.82-15.5 14.82-24.18h0A14.82 14.82 0 0 0 24 4.5m0 7.7a7.13 7.13 0 1 1-7.13 7.12A7.13 7.13 0 0 1 24 12.2' stroke-width='1'/%3E%3C/svg%3E");
}
.fa6-solid--building-circle-exclamation {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'%3E%3Cpath fill='%23fff' d='M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8c-32.9-32-53.3-76.7-53.3-126.2c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16m224 416a144 144 0 1 0 0-288a144 144 0 1 0 0 288m0-96a24 24 0 1 1 0 48a24 24 0 1 1 0-48m0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16'/%3E%3C/svg%3E");
}

.config-icon {
  cursor: pointer;
  color: #374151;
  transition: color 0.15s;
}
.config-icon:hover {
  color: #2563eb;
}

.add-module-btn {
  width: auto;
  height: 32px;
  padding: 0 12px;
  gap: 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1200px) {
  .filter-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .filter-row {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    flex-direction: column;
  }
}
</style>
<script src="./tenant.js"></script>